import type { RootState } from "@/app/store";
import { FormularioRespostaControle } from "@/contexts/fiscalizacao/formulario/model/FormularioRespostaControle";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormularioControleRespostaState {
  items: FormularioRespostaControle[];
  synced?: boolean;
  updatedAt?: number;
}

const initialState: FormularioControleRespostaState = {
  items: [],
  synced: false,
};

const formularioControleRespostaSlice = createSlice({
  name: "FORMULARIO_CONTROLE_RESPOSTA",
  initialState,
  reducers: {
    sync: {
      reducer: (
        state,
        action: PayloadAction<{ items: FormularioRespostaControle[] }>
      ) => {
        const { items } = action.payload;

        state.items = [...state.items, ...items];
        state.synced = true;
        state.updatedAt = Date.now();
      },
      prepare: (items: FormularioRespostaControle[]) => ({
        payload: { items },
      }),
    },

    removeMunicipio: {
      reducer: (state, action: PayloadAction<{ municipioId: number }>) => {
        const { municipioId } = action.payload;
        state.items = state.items.filter(
          (item) => item.municipio.id !== municipioId
        );
      },
      prepare: (municipioId: number) => ({
        payload: { municipioId },
      }),
    },
  },
});

export const formularioControleRespostaActions =
  formularioControleRespostaSlice.actions;

export default formularioControleRespostaSlice.reducer;

export const getFormularioControleRespostaSynced = (state: RootState) =>
  state.formularioControleResposta.items;

export const getFormularioControleRespostaIsSynced = (state: RootState) =>
  state.formularioControleResposta.synced;

export const getCountMunicipiosSynced = (state: RootState) => {
  const municipiosIds = state.formularioControleResposta.items.map(
    (f) => f.municipio.id
  );
  const uniqueMunicipiosIds = Array.from(new Set(municipiosIds));
  return uniqueMunicipiosIds.length;
};

export const getMunicipiosSincronizados = (state: RootState) => {
  const items = state.formularioControleResposta.items;
  const municipiosMap = new Map();

  items.forEach((item) => {
    if (!municipiosMap.has(item.municipio.id)) {
      municipiosMap.set(item.municipio.id, {
        id: item.municipio.id,
        nome: `${item.municipio.nome}-${item.municipio.uf.sigla}`,
        quantidadeFormularios: 0,
        dataUltimaAtualizacao: item.dataUltimaResposta,
      });
    }

    const municipio = municipiosMap.get(item.municipio.id);
    municipio.quantidadeFormularios += 1;
  });

  return Array.from(municipiosMap.values());
};
